import React from 'react';
import { PATHS } from '@constants';
import { isIOS } from 'react-device-detect';
import ConditionalRenderer, { Else, If } from '@components/ConditionalRenderer';
import HeaderMenuItem from '@components/HeaderMenuItem';
import googlePlay from '@img/google-play.svg';
import appStore from '@img/app-store.svg';
import './style.scss';

const menuItems = [
  { linkTo: PATHS.HOME, title: 'Home', icon: 'home' },
  { linkTo: PATHS.MY_SPACE, title: 'My Space', icon: 'users' },
  { linkTo: PATHS.STUDIES, title: 'Studies', icon: 'study' },
  { linkTo: PATHS.MAKE_SMILE, title: 'Make Smile', icon: 'smile' },
];

const HeaderMenu = () => (
  <div className='header__menu header-menu'>
    <div className='header-menu__wrap'>
      {menuItems.map(({ linkTo, title, icon }, index) => (
        <HeaderMenuItem key={index} linkTo={linkTo} title={title} icon={icon} greenTheme={linkTo === PATHS.MAKE_SMILE} />
      ))}
    </div>
    <div className='header-menu__footer'>
      <ConditionalRenderer condition={isIOS}>
        <If>
          <a className='mobile-download' href='https://apps.apple.com/us/app/vann-by-cancer-survivor/id1663619147' target='_blank' rel='noreferrer'>
            <img width={132} height={48} src={appStore} alt='App Store' />
          </a>
        </If>
        <Else>
          <a className='mobile-download' href='https://play.google.com/store/apps/details?id=com.thevann.vann&pcampaignid=web_share' target='_blank' rel='noreferrer'>
            <img width={147} height={48} src={googlePlay} alt='Google Play' />
          </a>
        </Else>
      </ConditionalRenderer>
    </div>
  </div>
);

export default HeaderMenu;
